import * as React from 'react'

import * as Style from './style.css'

export interface IProps {
  children: React.ReactNode
  isActive?: boolean
}

export const ProgressStep = ({ children, isActive }: IProps): JSX.Element => (
  <li className={isActive ? Style.ProgressStepActive : Style.ProgressStep}>
    <span className={Style.ProgressStepName}>{children}</span>
  </li>
)
